import { useState, useEffect } from 'react';
import { Link } from 'react-router';

/**
 * Sticky CTA Bar
 * - Appears after scrolling past 600px (past the hero section)
 * - Fixed at bottom of viewport
 * - Dark bar with gold "Request Early Access" button
 * - Font: font-mkt-sans (system-ui placeholder)
 *
 * Usage: <StickyCTA /> (rendered inside MarketingLayout)
 */
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t backdrop-blur-md"
      style={{
        backgroundColor: 'rgba(20,20,20,0.80)',
        borderColor: 'rgba(255,255,255,0.06)',
      }}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 gap-4">
          <p
            className="hidden sm:block text-sm"
            style={{ color: '#a8a29e' }}
          >
            Stop drowning in admin. Start scaling your practice.
          </p>
          <div className="flex items-center gap-4 ml-auto">
            <Link
              to="/early-access"
              className="rounded px-5 py-2 text-sm font-medium tracking-wide transition-opacity hover:opacity-90"
              style={{ backgroundColor: '#c9a96e', color: '#0c0c0c' }}
            >
              Request Early Access
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
